const brokerConnection = require('../../brokerConnection/brokerConnection');

const updateFrameThermoking = async (device_sn, isSuscribed, onDeviceObtained) => {
  const topic = `api/tkData/${device_sn}`;

  if (!isSuscribed) {
    await brokerConnection.suscribeToUpdate(topic, (msg) => {
      const notification = JSON.parse(msg.toString());
      onDeviceObtained(notification);
    });
  }
  return topic;
};
module.exports = { updateFrameThermoking };
